/**
 * Dashboard Router
 * 
 * Conditionally renders:
 * - OverviewDashboard (when no retailer selected) - has its own OverviewSidebar
 * - Dashboard (when specific retailer selected) - uses standard AppSidebar
 */

import React, { useState } from 'react';
import { useTenant } from '../contexts/TenantContext';
import { OverviewDateProvider } from '../contexts/OverviewDateContext';
import { AppSidebar } from '../components/AppSidebar';
import OverviewDashboard from './OverviewDashboard';
import Dashboard from './Dashboard';

export default function DashboardRouter() {
  const { selectedRetailerId } = useTenant();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // If no retailer selected, show overview (has its own sidebar)
  // Wrap with OverviewDateProvider for calendar-based date selection
  if (!selectedRetailerId) {
    return (
      <OverviewDateProvider>
        <OverviewDashboard />
      </OverviewDateProvider>
    );
  }

  // If retailer selected, show detail dashboard with standard sidebar
  return (
    <div className="flex">
      <AppSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
      <div className={`flex-1 transition-all duration-300 ${sidebarOpen ? 'ml-64' : 'ml-16'}`}>
        <div className="p-6">
          <Dashboard />
        </div>
      </div>
    </div>
  );
}

